/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MediaImageSignUploadPathParams,
	MediaImageSignUploadRequest,
	MediaImageSignUploadResponse,
} from '../types/MediaImageSignUpload'

/**
 * POST /media/:organisation/images/signed-url
 * @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::signUpload
 */
export async function mediaImageSignUpload(
	organisation: MediaImageSignUploadPathParams['organisation'],
	data: MediaImageSignUploadRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MediaImageSignUploadResponse>> {
	return axiosInstance.post(`/media/${organisation}/images/signed-url`, data, config)
}
